"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
var Option = antd_1.Select.Option;
var _isEqual = require('lodash/isEqual');
var UploadButton_1 = __importDefault(require("../../UploadButton/UploadButton"));
var WfsParserInput_1 = __importDefault(require("../WfsParserInput/WfsParserInput"));
var LocaleWrapper_1 = require("../../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../../locale/en_US"));
var DataLoader = /** @class */ (function (_super) {
    __extends(DataLoader, _super);
    function DataLoader(props) {
        var _this = _super.call(this, props) || this;
        _this.parseGeoJsonUploadData = function (uploadObject) {
            var activeParser = _this.state.activeParser;
            if (!activeParser) {
                return;
            }
            var file = uploadObject.file;
            var reader = new FileReader();
            reader.readAsText(file);
            reader.onload = function () {
                var fileContent = reader.result.toString();
                // TODO: Remove JSON.parse when type of readData is more precise
                activeParser.readData(JSON.parse(fileContent))
                    .then(function (data) {
                    _this.props.onDataRead(data);
                    uploadObject.onSuccess(null, uploadObject.file);
                })
                    .catch(function (e) {
                    uploadObject.onError(e, 'Upload failed. Invalid Data.');
                });
            };
        };
        _this.parseShapefileUploadData = function (uploadObject) {
            var activeParser = _this.state.activeParser;
            if (!activeParser) {
                return;
            }
            var file = uploadObject.file;
            var reader = new FileReader();
            reader.readAsArrayBuffer(file);
            reader.onload = function () {
                activeParser.readData(reader.result)
                    .then(function (data) {
                    _this.props.onDataRead(data);
                    uploadObject.onSuccess(null, uploadObject.file);
                })
                    .catch(function (e) {
                    uploadObject.onError(e, 'Upload failed. Invalid Data.');
                });
            };
        };
        _this.parseWfsData = function (wfsReadParams) {
            var activeParser = _this.state.activeParser;
            if (!activeParser) {
                return;
            }
            // The dataProjection of the Preview
            wfsReadParams.srsName = 'EPSG:4326';
            activeParser.readData(wfsReadParams)
                .then(function (data) {
                _this.props.onDataRead(data);
                _this.setState({
                    modalVisible: false
                });
            });
        };
        _this.getParserOptions = function () {
            return _this.props.parsers.map(function (parser) {
                return React.createElement(Option, { key: parser.title, value: parser.title }, parser.title);
            });
        };
        _this.onSelect = function (selection) {
            var activeParser = _this.props.parsers.find(function (parser) { return parser.title === selection; });
            if (activeParser) {
                _this.setState({
                    activeParser: activeParser,
                    modalVisible: activeParser.title === 'WFS Data Parser'
                });
            }
        };
        _this.closeModal = function () {
            _this.setState({ modalVisible: false });
        };
        _this.getInputFromParser = function () {
            var activeParser = _this.state.activeParser;
            if (activeParser) {
                switch (activeParser.title) {
                    case 'GeoJSON Data Parser':
                        return (React.createElement(UploadButton_1.default, { onUpload: _this.parseGeoJsonUploadData }));
                    case 'Shapefile Data Parser':
                        return (React.createElement(UploadButton_1.default, { onUpload: _this.parseShapefileUploadData }));
                    case 'WFS Data Parser':
                        return (React.createElement(antd_1.Modal, { className: "wfs-parser-modal", title: activeParser.title, visible: _this.state.modalVisible, onCancel: _this.closeModal, onOk: _this.closeModal },
                            React.createElement(WfsParserInput_1.default, { onClick: _this.parseWfsData })));
                    default:
                        return (React.createElement(UploadButton_1.default, { onUpload: _this.parseGeoJsonUploadData }));
                }
            }
            return null;
        };
        _this.state = {
            modalVisible: false
        };
        return _this;
    }
    DataLoader.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var diffProps = !_isEqual(this.props, nextProps);
        var diffState = !_isEqual(this.state, nextState);
        return diffProps || diffState;
    };
    DataLoader.prototype.render = function () {
        var activeParser = this.state.activeParser;
        var locale = this.props.locale;
        return (React.createElement("div", { className: activeParser ? 'gs-dataloader-right' : '' },
            locale.label,
            React.createElement(antd_1.Select, { style: { width: 300 }, onSelect: this.onSelect }, this.getParserOptions()),
            this.getInputFromParser()));
    };
    DataLoader.componentName = 'DataLoader';
    DataLoader.defaultProps = {
        locale: en_US_1.default.GsDataLoader,
        onDataRead: function (data) { return; }
    };
    return DataLoader;
}(React.Component));
exports.DataLoader = DataLoader;
exports.default = LocaleWrapper_1.localize(DataLoader, DataLoader.componentName);
//# sourceMappingURL=DataLoader.js.map